import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE.  DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ContactDuplicateIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsxs(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "ContactDuplicate",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M23.27 13.1c.94-.1 1.77-.52 2.39-1.35.94-1.35 1.46-2.91 1.46-4.47v-.21c.1-2.18-1.56-3.95-3.74-4.06s-3.95 1.56-4.06 3.74v.62c0 1.66.52 3.22 1.46 4.47.62.73 1.46 1.14 2.5 1.25Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M29.61 14.34c-.83-.94-1.77-1.66-2.91-2.18-.73 1.25-2.08 1.98-3.54 2.08-1.46-.1-2.7-.83-3.54-2.08l-.31.1c0 1.46-.31 2.81-.83 4.16-.1.21 0 .42.21.52.94.52 1.87 1.14 2.7 1.87.1 0 .1.1.21.1.52.1 1.04.21 1.56.21 2.5 0 4.78-1.04 6.45-2.91.52-.62.52-1.35 0-1.87M16.92 19.02l-.1-.1c-1.14 1.77-3.02 2.91-5.1 3.02-2.08-.1-3.95-1.25-5.1-2.91-1.56.73-3.02 1.77-4.16 3.12-.62.73-.62 1.77 0 2.5 4.37 5.2 12.17 5.82 17.37 1.46.52-.42.94-.83 1.35-1.35.21-.31.42-.83.31-1.25 0-.42-.21-.94-.52-1.25-1.04-1.46-2.39-2.5-4.06-3.22Z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11.72 20.27c1.46-.1 2.7-.83 3.54-1.98 1.35-1.87 2.08-4.16 2.08-6.55v-.31c0-3.12-2.5-5.72-5.72-5.72S6 8.31 6 11.43v.31c0 2.39.73 4.68 2.18 6.55.83 1.25 2.08 1.87 3.54 1.98"
    })]
  }));
};